/* Ottomara (6 Oct 2026, v2): real chair images for the home hero and builder. Every frame x sling is selectable.
   Picture for a build, best first:
   0. Cleaned builder photo in Shopify Files (ot-<bos|chg>-<frame>-<sling>.jpg): real render or labelled color preview
   1. Factory studio render of that exact build, uploaded to Shopify Files as ot-<bos|chg>-<frame>-<sling>.png
   2. The Shopify variant image of that exact build
   3. A render of the same model in the same frame (or the closest frame), with the sling, and if needed the frame,
      digitally recolored. Labelled "Color preview".
   8 Oct: ChillGo uses the angled 3/4 set (chg3-<frame>-<sling>.jpg). Personalization is drawn on the cleaned photo
   of the exact build (headrest mapped per model), falling back to Shopify variant images.
   Every picture is auto-cropped to the chair, so renders shot at different distances line up. */
(function () {
  var PHOTOS = null;
  function photos() {
    if (PHOTOS) return PHOTOS;
    PHOTOS = {};
    var el = document.getElementById('otPhotos');
    if (el) { try { JSON.parse(el.textContent).forEach(function (p) { if (p && p[1]) PHOTOS[p[0]] = p[1]; }); } catch (e) {} }
    return PHOTOS;
  }
  // Factory renders copied to Drive on 6 Oct 2026 for upload to Shopify Files (Content > Files).
  var FILES_BASE = (window.OT_FILES_BASE || '/cdn/shop/files/');
  var FACTORY = {
    bosphorus: {
      Silver: ['Anthracite', 'Yucca', 'Turquoise', 'Dark Green', 'Gold Black', 'Carrot', 'Jeans', 'Chestnut', 'Latte'],
      Cappuccino: ['Yucca', 'Anthracite', 'Chestnut', 'Jeans', 'Latte'],
      Anthracite: ['Yucca', 'Latte', 'Jeans', 'Anthracite'],
      Teak: ['Anthracite', 'Yucca', 'Gold Black', 'Jeans', 'Latte']
    },
    chillgo: {
      Silver: ['Anthracite', 'Dark Green', 'Gold Black', 'Turquoise', 'Carrot', 'Yucca', 'Latte', 'Jeans', 'Melon'],
      Anthracite: ['Turquoise', 'Carrot', 'Latte', 'Yucca', 'Jeans', 'Melon', 'Anthracite'],
      Cappuccino: ['Chestnut'],
      Teak: ['Anthracite']
    }
  };
  var SLUG = { bosphorus: 'bos', chillgo: 'chg' };
  function slug(s) { return String(s).toLowerCase().replace(/\s+/g, '-'); }
  function factoryUrl(model, frame, mesh) {
    var l = (FACTORY[model] || {})[frame];
    if (!l || l.indexOf(mesh) < 0) return null;
    return FILES_BASE + 'ot-' + SLUG[model] + '-' + slug(frame) + '-' + slug(mesh) + '.png?width=1600';
  }
  // 7 Oct 2026: cleaned builder photos (Shopify Files, ot-<bos|chg>-<frame>-<sling>.jpg, 1600x1000, even studio backdrop).
  // R = studio render of that exact build; P = color preview made from our studio renders of that frame and that sling.
  var BUILT_R = 'bos-silver-anthracite bos-silver-chestnut bos-silver-turquoise bos-silver-dark-green bos-cappuccino-anthracite bos-cappuccino-jeans bos-cappuccino-yucca bos-anthracite-anthracite bos-anthracite-latte bos-anthracite-jeans bos-anthracite-yucca bos-teak-anthracite bos-teak-yucca bos-teak-gold-black chg-silver-anthracite chg-silver-latte chg-silver-jeans chg-silver-yucca chg-silver-gold-black chg-silver-carrot chg-silver-melon chg-silver-turquoise chg-silver-dark-green chg-cappuccino-chestnut chg-anthracite-anthracite chg-anthracite-latte chg-anthracite-jeans chg-anthracite-yucca chg-anthracite-carrot chg-anthracite-melon chg-anthracite-turquoise chg-teak-anthracite'.split(' ');
  var BUILT_P = 'bos-silver-latte bos-silver-jeans bos-silver-yucca bos-silver-gold-black bos-silver-carrot bos-silver-melon bos-cappuccino-latte bos-cappuccino-chestnut bos-cappuccino-gold-black bos-cappuccino-carrot bos-cappuccino-melon bos-cappuccino-turquoise bos-cappuccino-dark-green bos-anthracite-chestnut bos-anthracite-gold-black bos-anthracite-carrot bos-anthracite-melon bos-anthracite-turquoise bos-anthracite-dark-green bos-teak-chestnut bos-teak-carrot bos-teak-melon bos-teak-turquoise bos-teak-dark-green chg-silver-chestnut chg-cappuccino-anthracite chg-cappuccino-latte chg-cappuccino-jeans chg-cappuccino-yucca chg-cappuccino-gold-black chg-cappuccino-carrot chg-cappuccino-melon chg-cappuccino-turquoise chg-cappuccino-dark-green chg-anthracite-chestnut chg-anthracite-gold-black chg-anthracite-dark-green chg-teak-latte chg-teak-jeans chg-teak-yucca chg-teak-chestnut chg-teak-gold-black chg-teak-carrot chg-teak-melon chg-teak-turquoise chg-teak-dark-green'.split(' ');
  // 7 Oct (later): re-made in the Teak/Anthracite camera view; uploaded as ot2-<...>.jpg
  var V2 = 'bos-silver-latte bos-silver-jeans bos-silver-yucca bos-silver-gold-black bos-silver-carrot bos-silver-melon bos-cappuccino-chestnut bos-cappuccino-latte chg-silver-anthracite chg-silver-carrot chg-silver-dark-green chg-silver-gold-black'.split(' ');
  // 8 Oct: previews rebuilt so the sling never paints over the frame; uploaded as v5-<...>.jpg
  var V5 = 'bos-anthracite-carrot bos-anthracite-chestnut bos-anthracite-dark-green bos-anthracite-gold-black bos-anthracite-melon bos-anthracite-turquoise bos-cappuccino-carrot bos-cappuccino-chestnut bos-cappuccino-dark-green bos-cappuccino-gold-black bos-cappuccino-latte bos-cappuccino-melon bos-cappuccino-turquoise bos-teak-carrot bos-teak-chestnut bos-teak-dark-green bos-teak-melon bos-teak-turquoise chg-anthracite-chestnut chg-anthracite-dark-green chg-anthracite-gold-black chg-cappuccino-anthracite chg-cappuccino-carrot chg-cappuccino-dark-green chg-cappuccino-gold-black chg-cappuccino-jeans chg-cappuccino-latte chg-cappuccino-melon chg-cappuccino-turquoise chg-cappuccino-yucca chg-silver-chestnut chg-teak-carrot chg-teak-chestnut chg-teak-dark-green chg-teak-gold-black chg-teak-jeans chg-teak-latte chg-teak-melon chg-teak-turquoise chg-teak-yucca'.split(' ');
  var BUILT = {};
  BUILT_R.forEach(function (k) { BUILT[k] = 'render'; });
  BUILT_P.forEach(function (k) { BUILT[k] = 'preview'; });
  function builtUrl(model, frame, mesh) {
    var k = SLUG[model] + '-' + slug(frame) + '-' + slug(mesh);
    return BUILT[k] ? { url: FILES_BASE + (V5.indexOf(k) > -1 ? 'v5-' + k : (k.indexOf('chg-') === 0 ? 'chg3-' + k.slice(4) : (V2.indexOf(k) > -1 ? 'ot2-' : 'ot-') + k)) + '.jpg?width=1600', kind: BUILT[k] } : null;
  }
  // Recolor bases, tried in order. src 'f' = factory file, 'v' = Shopify variant image.
  // mode: how the base sling is found ('jeans' = blue-grey sling, 'carrot' = orange sling).
  var BASES = {
    bosphorus: {
      Anthracite: [{ src: 'f', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans' }, { src: 'v', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans' }],
      Teak: [{ src: 'f', frame: 'Teak', mesh: 'Jeans', mode: 'jeans' }, { src: 'v', frame: 'Teak', mesh: 'Jeans', mode: 'jeans' }],
      Silver: [{ src: 'f', frame: 'Silver', mesh: 'Jeans', mode: 'jeans' }, { src: 'v', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans' }],
      Cappuccino: [{ src: 'f', frame: 'Cappuccino', mesh: 'Jeans', mode: 'jeans' }, { src: 'v', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans' }]
    },
    chillgo: {
      Silver: [{ src: 'f', frame: 'Silver', mesh: 'Jeans', mode: 'jeans', ext: 0.6 }, { src: 'v', frame: 'Anthracite', mesh: 'Carrot', mode: 'carrot' }],
      Anthracite: [{ src: 'f', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans', ext: 0.6 }, { src: 'v', frame: 'Anthracite', mesh: 'Carrot', mode: 'carrot' }],
      Teak: [{ src: 'f', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans', ext: 0.6 }, { src: 'v', frame: 'Anthracite', mesh: 'Carrot', mode: 'carrot' }],
      Cappuccino: [{ src: 'f', frame: 'Anthracite', mesh: 'Jeans', mode: 'jeans', ext: 0.6 }, { src: 'v', frame: 'Anthracite', mesh: 'Carrot', mode: 'carrot' }]
    }
  };
  // Bases with a mapped headrest (Shopify variant images), used when the build is personalized.
  var PERS_BASES = {
    bosphorus: { Anthracite: 'Anthracite', Teak: 'Teak', Silver: 'Anthracite', Cappuccino: 'Anthracite' },
    chillgo: { Anthracite: 'Anthracite', Teak: 'Anthracite', Silver: 'Anthracite', Cappuccino: 'Anthracite' }
  };
  var PERS_MODE = { bosphorus: { mesh: 'Jeans', mode: 'jeans' }, chillgo: { mesh: 'Carrot', mode: 'carrot' } };
  // Colors used when recoloring a render (tuned to read like the swatch on a lit photo).
  var SLING = { Anthracite: '#55585C', Latte: '#E6DECC', Jeans: '#7F8898', Yucca: '#A3B05E', Chestnut: '#8F847A', 'Gold Black': '#5A463D', Carrot: '#EE7F38', Melon: '#EEC437', Turquoise: '#74B0C3', 'Dark Green': '#36493F' };
  var FRAME = { Silver: '#C9CDD1', Cappuccino: '#8C7F6F', Anthracite: '#3B3F43', Teak: '#9A6A3E' };
  // 8 Oct: print area on the headrest of the cleaned photos, as a perspective quad (TL, TR, BR, BL; fractions of the image).
  var PRINTQ = {
    bosphorus: [[0.1865, 0.1455], [0.3144, 0.123], [0.3389, 0.233], [0.2082, 0.2592]],
    chillgo: [[0.2679, 0.1888], [0.4095, 0.1492], [0.4379, 0.2751], [0.2994, 0.3195]]
  };
  // Headrest position on the Shopify variant images (fractions of the source image).
  var HEAD = {
    bosphorus: { x: 0.395, y: 0.455, w: 0.095, rot: 0, skew: 19 },
    chillgo: { x: 0.648, y: 0.29, w: 0.2, rot: 10, skew: -15 }
  };

  var imgCache = {}, srcCache = {}, maskCache = {};
  function load(url) {
    if (!imgCache[url]) imgCache[url] = new Promise(function (res, rej) { var i = new Image(); i.decoding = 'async'; i.onload = function () { res(i); }; i.onerror = function () { rej(new Error('load ' + url)); }; i.src = url; });
    return imgCache[url];
  }
  // Decoded pixels, with any transparency flattened onto white.
  function pixels(url) {
    if (!srcCache[url]) srcCache[url] = load(url).then(function (im) {
      var c = document.createElement('canvas'); c.width = im.naturalWidth; c.height = im.naturalHeight;
      var x = c.getContext('2d', { willReadFrequently: true }); x.fillStyle = '#FFFFFF'; x.fillRect(0, 0, c.width, c.height); x.drawImage(im, 0, 0);
      return { w: c.width, h: c.height, d: x.getImageData(0, 0, c.width, c.height).data };
    });
    return srcCache[url];
  }
  function hex(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }

  // Background colour (median of the four corners) and the chair's bounding box.
  function frameBox(a) {
    var w = a.w, h = a.h, d = a.d, k = Math.max(4, Math.round(Math.min(w, h) * 0.02)), samples = [[], [], []], i, x, y, c;
    [[0, 0], [w - k, 0], [0, h - k], [w - k, h - k]].forEach(function (o) {
      for (y = o[1]; y < o[1] + k; y++) for (x = o[0]; x < o[0] + k; x++) { i = (y * w + x) * 4; for (c = 0; c < 3; c++) samples[c].push(d[i + c]); }
    });
    var bg = samples.map(function (s) { s.sort(function (p, q) { return p - q; }); return s[s.length >> 1]; });
    var cols = new Uint32Array(w), rows = new Uint32Array(h);
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = (y * w + x) * 4;
      if (Math.max(Math.abs(d[i] - bg[0]), Math.abs(d[i + 1] - bg[1]), Math.abs(d[i + 2] - bg[2])) > 34) { cols[x]++; rows[y]++; }
    }
    var tc = Math.max(3, h * 0.006), tr = Math.max(3, w * 0.006), x0 = 0, x1 = w - 1, y0 = 0, y1 = h - 1;
    while (x0 < w - 1 && cols[x0] < tc) x0++;
    while (x1 > x0 && cols[x1] < tc) x1--;
    while (y0 < h - 1 && rows[y0] < tr) y0++;
    while (y1 > y0 && rows[y1] < tr) y1--;
    if (x1 - x0 < w * 0.1 || y1 - y0 < h * 0.1) { x0 = 0; y0 = 0; x1 = w - 1; y1 = h - 1; }
    return { bg: bg, x0: x0, y0: y0, x1: x1, y1: y1 };
  }

  function mask(a, mode, ext) {
    var w = a.w, h = a.h, d = a.d, n = w * h, s = new Float32Array(n), f = new Float32Array(n);
    var x0 = w, x1 = 0, y0 = h, y1 = 0, p, i, x, y;
    var Ls = new Float32Array(n), Cs = new Float32Array(n);
    for (p = 0, i = 0; p < n; p++, i += 4) {
      var r = d[i], g = d[i + 1], b = d[i + 2];
      Ls[p] = 0.299 * r + 0.587 * g + 0.114 * b; Cs[p] = Math.max(r, g, b) - Math.min(r, g, b);
      var isS = mode === 'jeans' ? (b - r > 5 && Ls[p] < 210 && Ls[p] > 35) : (r - b > 40);
      if (isS) s[p] = 1;
    }
    // keep only sling regions at least 3% the size of the largest (drops tinted shadow specks)
    var lab = new Int32Array(n), sizes = [0], st2 = [], q2, cnt, big = 0, k2;
    for (p = 0; p < n; p++) if (s[p] && !lab[p]) {
      k2 = sizes.length; cnt = 0; st2.push(p); lab[p] = k2;
      while (st2.length) { q2 = st2.pop(); cnt++; x = q2 % w;
        if (x > 0 && s[q2 - 1] && !lab[q2 - 1]) { lab[q2 - 1] = k2; st2.push(q2 - 1); }
        if (x < w - 1 && s[q2 + 1] && !lab[q2 + 1]) { lab[q2 + 1] = k2; st2.push(q2 + 1); }
        if (q2 >= w && s[q2 - w] && !lab[q2 - w]) { lab[q2 - w] = k2; st2.push(q2 - w); }
        if (q2 < n - w && s[q2 + w] && !lab[q2 + w]) { lab[q2 + w] = k2; st2.push(q2 + w); } }
      sizes.push(cnt); if (cnt > big) big = cnt;
    }
    for (p = 0; p < n; p++) if (s[p]) { if (sizes[lab[p]] < big * 0.03) s[p] = 0; else { x = p % w; y = (p / w) | 0; if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
    // fill holes in the sling (highlights that lose their tint): anything not reachable from the image edge
    var seen = new Uint8Array(n), stack = [];
    for (x = 0; x < w; x++) { stack.push(x, (h - 1) * w + x); }
    for (y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
    while (stack.length) { p = stack.pop(); if (seen[p] || s[p]) continue; seen[p] = 1; x = p % w; if (x > 0) stack.push(p - 1); if (x < w - 1) stack.push(p + 1); if (p >= w) stack.push(p - w); if (p < n - w) stack.push(p + w); }
    for (p = 0; p < n; p++) if (!seen[p] && !s[p]) s[p] = 1;
    // frame: dark neutral pixels plus lighter neutral pixels that touch them, near the chair
    var pad = Math.round(w * 0.04), core = new Uint8Array(n);
    x0 -= pad; x1 += pad; y0 -= pad; y1 += Math.round(h * (ext != null ? ext : (mode === 'carrot' ? 0.4 : 0.1)));
    var coreL = mode === 'jeans' ? 105 : 120, candL = mode === 'jeans' ? 165 : 175, R = Math.max(2, Math.round(w / 450));
    for (p = 0; p < n; p++) if (!s[p] && Ls[p] < coreL && Cs[p] < 24) core[p] = 1;
    var near = new Uint8Array(n);
    for (p = 0; p < n; p++) if (core[p]) { x = p % w; y = (p / w) | 0; for (var dy = -R; dy <= R; dy++) for (var dx = -R; dx <= R; dx++) { var xx = x + dx, yy = y + dy; if (xx >= 0 && xx < w && yy >= 0 && yy < h) near[yy * w + xx] = 1; } }
    for (p = 0; p < n; p++) {
      if (s[p]) continue; x = p % w; y = (p / w) | 0;
      if (x < x0 || x > x1 || y < y0 || y > y1) continue;
      if (core[p] || (near[p] && Ls[p] < candL && Cs[p] < 24)) f[p] = 1;
    }
    function blur(m) { var o = new Float32Array(m.length); for (var yy2 = 1; yy2 < h - 1; yy2++) for (var xx2 = 1; xx2 < w - 1; xx2++) { var q = yy2 * w + xx2; o[q] = (m[q] * 4 + m[q - 1] + m[q + 1] + m[q - w] + m[q + w]) / 8; } return o; }
    function med(m) { var t = 0, c = 0; for (var q = 0; q < n; q++) if (m[q] > 0.9) { t += Ls[q]; c++; } return c ? t / c : 128; }
    return { s: blur(s), f: blur(f), ms: med(s), mf: med(f) };
  }

  function recolor(a, M, sling, frame) {
    var o = new Uint8ClampedArray(a.d), S = sling && hex(sling), F = frame && hex(frame), d = a.d;
    for (var p = 0, i = 0; p < M.s.length; p++, i += 4) {
      var L = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2], t, k, c;
      if (S && M.s[p] > 0) { t = M.s[p]; k = Math.pow(L / M.ms, 0.9); for (c = 0; c < 3; c++) o[i + c] = d[i + c] * (1 - t) + Math.min(255, S[c] * k) * t; }
      if (F && M.f[p] > 0) { t = M.f[p]; k = Math.pow(L / M.mf, 0.6); for (c = 0; c < 3; c++) o[i + c] = o[i + c] * (1 - t) + Math.min(255, F[c] * k) * t; }
    }
    return o;
  }

  // ---- 8 Oct: personalization laid on the headrest ----
  function fontReady(t) {
    if (!t || !document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load('64px ' + t.family, t.str).catch(function () {});
  }
  // 8 Oct v7: crisp design laid flat on the headrest. An affine fitted to the print area keeps the
  // baseline parallel to the top rail and the letters leaning with the side rails.
  function affineOn(ox, a, q, opts) {
    var P = q.map(function (p) { return [p[0] * a.w, p[1] * a.h]; });
    var ex = [((P[1][0] - P[0][0]) + (P[2][0] - P[3][0])) / 2, ((P[1][1] - P[0][1]) + (P[2][1] - P[3][1])) / 2];
    var ey = [((P[3][0] - P[0][0]) + (P[2][0] - P[1][0])) / 2, ((P[3][1] - P[0][1]) + (P[2][1] - P[1][1])) / 2];
    var W = Math.hypot(ex[0], ex[1]), H = Math.hypot(ey[0], ey[1]);
    var cx = (P[0][0] + P[1][0] + P[2][0] + P[3][0]) / 4, cy = (P[0][1] + P[1][1] + P[2][1] + P[3][1]) / 4;
    ox.save();
    ox.transform(ex[0] / W, ex[1] / W, ey[0] / H, ey[1] / H, cx, cy);
    if (opts.art) {
      var im = opts.art, ar = im.naturalWidth / im.naturalHeight, aw = W * 0.9, ah = aw / ar;
      if (ah > H * 0.85) { ah = H * 0.85; aw = ah * ar; }
      ox.globalCompositeOperation = 'multiply'; ox.globalAlpha = 0.92;
      ox.drawImage(im, -aw / 2, -ah / 2, aw, ah);
    } else {
      var t = opts.text, size = H * 0.58;
      ox.font = Math.round(size) + 'px ' + t.family;
      var mw = ox.measureText(t.str).width;
      if (mw > W * 0.86) { size = size * W * 0.86 / mw; ox.font = Math.round(size) + 'px ' + t.family; }
      ox.textAlign = 'center'; ox.textBaseline = 'middle'; ox.fillStyle = t.color; ox.globalAlpha = 0.96;
      ox.shadowColor = 'rgba(0,0,0,0.18)'; ox.shadowBlur = size * 0.04; ox.shadowOffsetY = size * 0.02;
      ox.fillText(t.str, 0, size * 0.03);
    }
    ox.restore();
  }

  // The list of pictures to try for a build, best first.
  function candidates(opts) {
    var P = photos(), m = opts.model, out = [], pers = !!((opts.text && opts.text.str) || opts.art);
    var vkey = m + '|' + opts.frame + '|' + opts.mesh;
    var bu = builtUrl(m, opts.frame, opts.mesh); if (bu) out.push({ url: bu.url, src: 'b', kind: bu.kind });
    if (!pers) {
      var fu = factoryUrl(m, opts.frame, opts.mesh); if (fu) out.push({ url: fu, src: 'f' });
    }
    if (P[vkey]) out.push({ url: P[vkey], src: 'v' });
    if (!pers) {
      ((BASES[m] || {})[opts.frame] || []).forEach(function (b) {
        var u = b.src === 'f' ? factoryUrl(m, b.frame, b.mesh) : P[m + '|' + b.frame + '|' + b.mesh];
        if (u) out.push({ url: u, src: b.src, base: b });
      });
    }
    var pf = (PERS_BASES[m] || {})[opts.frame], pm = PERS_MODE[m];
    if (pf && pm && P[m + '|' + pf + '|' + pm.mesh]) out.push({ url: P[m + '|' + pf + '|' + pm.mesh], src: 'v', base: { src: 'v', frame: pf, mesh: pm.mesh, mode: pm.mode } });
    return out;
  }
  function firstLoaded(list, i) {
    if (i >= list.length) return Promise.reject(new Error('no picture'));
    return pixels(list[i].url).then(function (a) { return { c: list[i], a: a }; }, function () { return firstLoaded(list, i + 1); });
  }

  // Draw the chosen build into `canvas` (sized by the caller via CSS; aspect = width / height).
  // opts: { model, frame, mesh, aspect, text: {str, family, color}, art: HTMLImageElement }
  // Resolves to { kind: 'render'|'preview'|'none', base: 'Anthracite / Jeans' }.
  function render(canvas, opts) {
    var job = (canvas._otJob = (canvas._otJob || 0) + 1);
    return firstLoaded(candidates(opts), 0).then(function (hit) { return fontReady(opts.text && opts.text.str ? opts.text : null).then(function () { return hit; }); }).then(function (hit) {
      if (job !== canvas._otJob) return null;
      var a = hit.a, c = hit.c, base = c.base || null, data = a.d;
      if (base) {
        var mk = maskCache[c.url] || (maskCache[c.url] = mask(a, base.mode, base.ext));
        data = recolor(a, mk, opts.mesh !== base.mesh ? SLING[opts.mesh] : null, opts.frame !== base.frame ? FRAME[opts.frame] : null);
      }
      var box = a.box || (a.box = frameBox(a));
      var off = document.createElement('canvas'); off.width = a.w; off.height = a.h;
      var ox = off.getContext('2d'); ox.putImageData(new ImageData(new Uint8ClampedArray(data), a.w, a.h), 0, 0);
      // personalization drawn onto the headrest in source space (cleaned photos and Shopify variant images)
      var hasPers = (opts.text && opts.text.str) || opts.art;
      if (c.src === 'b' && hasPers && PRINTQ[opts.model]) affineOn(ox, a, PRINTQ[opts.model], opts);
      var hd = HEAD[opts.model];
      if (c.src === 'v' && hd && hasPers) {
        var hw = hd.w * a.w;
        ox.save(); ox.translate(hd.x * a.w, hd.y * a.h); ox.rotate(hd.rot * Math.PI / 180); ox.transform(1, 0, Math.tan(hd.skew * Math.PI / 180), 1, 0, 0);
        ox.globalCompositeOperation = 'multiply'; ox.globalAlpha = 0.92;
        if (opts.art) {
          var ar = opts.art.naturalWidth / opts.art.naturalHeight, aw = hw, ah = hw / ar;
          if (ah > hw * 0.7) { ah = hw * 0.7; aw = ah * ar; }
          ox.drawImage(opts.art, -aw / 2, -ah / 2, aw, ah);
        } else {
          ox.globalCompositeOperation = 'source-over';
          var size = hw / Math.max(opts.text.str.length, 4) * 1.7;
          ox.font = Math.round(size) + 'px ' + opts.text.family; ox.textAlign = 'center'; ox.textBaseline = 'middle';
          ox.fillStyle = opts.text.color; ox.fillText(opts.text.str, 0, 0, hw * 0.95);
        }
        ox.restore();
      }
      // fit the chair's bounding box into the canvas with even margins, on the render's own background colour
      var A = opts.aspect || 1.6, cw = 1400, chh = Math.round(cw / A);
      canvas.width = cw; canvas.height = chh;
      var cx = canvas.getContext('2d');
      cx.fillStyle = 'rgb(' + box.bg.join(',') + ')'; cx.fillRect(0, 0, cw, chh);
      var bw = box.x1 - box.x0 + 1, bh = box.y1 - box.y0 + 1, padX = 0.08, padY = 0.1;
      var scale = Math.min(cw * (1 - 2 * padX) / bw, chh * (1 - 2 * padY) / bh);
      var dw = bw * scale, dh = bh * scale, dx = (cw - dw) / 2, dy = (chh - dh) / 2;
      cx.imageSmoothingQuality = 'high';
      // draw the whole source so edges of the background carry on past the box
      cx.drawImage(off, dx - box.x0 * scale, dy - box.y0 * scale, a.w * scale, a.h * scale);
      if (c.kind) return { kind: c.kind, base: c.kind === 'preview' ? 'studio' : '' };
      return { kind: base ? 'preview' : 'render', base: base ? base.frame + ' / ' + base.mesh : '' };
    }).catch(function () { return job === canvas._otJob ? { kind: 'none' } : null; });
  }

  window.OTPhoto = {
    render: render,
    has: function (k) { return !!photos()[k]; },
    url: function (k) { return photos()[k]; },
    _t: { mask: mask, recolor: recolor, frameBox: frameBox, candidates: candidates, factoryUrl: factoryUrl }
  };
})();
